module.exports = __webpack_public_path__ + "static/WARGAME_ERDAL_BEY-d1eae45ea7b1f3b41ae628b40a4dc7ee.png";